import mergeSort from '../../../Utils/mergeSort';

// Credit to https://github.com/moroshko/autosuggest-highlight/issues/5#issuecomment-344268622
// Using this until pull request has been approved and merged https://github.com/moroshko/autosuggest-highlight/pull/6

const specialCharsRegex = /[.*+?^${}()|[\]\\]/g;
const whitespacesRegex = /\s+/;

function escapeRegexCharacters(str: any) {
  return str.replace(specialCharsRegex, '\\$&');
}

const match = (text: any, query: any) => {
  return mergeSort(
    query
      .trim()
      .split(whitespacesRegex)
      // If query is blank, we'll get empty string here, so let's filter it out.
      .filter((word: any) => {
        return word.length > 0;
      })
      .reduce((result: any, word: any) => {
        const wordLen = word.length;
        const regex = new RegExp(escapeRegexCharacters(word), 'i');
        let index = text.match(regex);
        if (index) {
          index = index.index;
        } else {
          index = -1;
        }
        if (index > -1) {
          result.push([index, index + wordLen]);

          // Replace what we just found with spaces so we don't find it again.
          text =
            text.slice(0, index) +
            new Array(wordLen + 1).join(' ') +
            text.slice(index + wordLen);
        }

        return result;
      }, []),
    (match1: any, match2: any) => {
      return match1[0] - match2[0];
    }
  );
};

export default match;
